module.exports = __webpack_public_path__ + "img/ic_services_smokingzone.53ba2ed8.svg";